import { ControlExportData } from "./ControlExportData";

export class AdvancedEffectivenessExportParametersModel {
    items: ControlExportData[];
    userTimeZone: string;
}
